﻿$.fn.dxCtrlTelephone = function custom_dxCtrlTelephone(option) {
    if (option == "instance") {
        return this.instance;
    } else {
        this.addClass("dx-dxctrltelephone dx-ctrl");
        this.createInstance(new cdxCtrlTelephone(this, option));
    }
    return this;
}

window.errorMapTelephone = [
    "Numéro invalide",
    "Code Pays invalide",
    "Numéro trop court",
    "Numéro trop long",
    "Le numéro saisi est un numéro de mobile alors que c'est un numéro fixe qui est demandé",
    "Le numéro saisi est un numéro fixe alors que c'est un numéro de mobile qui est demandé"
];

window.cdxCtrlTelephone = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        } else {
            option[name] = value;
        }
    }

    // Initialisation des valeurs par défaut
    if (typeof option.value == 'undefined' || option.value == null) {
        option.value = {
            tel_code_pays: "fr",
            tel_indic_pays: "33",
            tel_number: "",
            tel_complet: "",
            tel_sms: "",
            tel_error: -1,
            tel_num_type: "-1"
        };
    }
    if (typeof option.typeTel == 'undefined') option.typeTel = 'tel';

    var dxItiTel = null;
    var isDirty = false;
    var oldValue = null;

    function mConstruit() {
        container.empty();

        //if (option.value == null) {
        //    option.value = {
        //        tel_code_pays: "",
        //        tel_number: "",
        //        tel_complet: "",
        //        tel_sms: "",
        //        tel_error: -1,
        //        tel_num_type: 0
        //    }
        //}
        if (typeof option.obligatoire != 'undefined' && option.obligatoire) {
            container.addClass("saisie_obligatoire");
        }

        if (option.labelMode == "floating") {
            container.css({ "position": "relative" }) //, "padding-top": "15px" })
            $DivLabel = $('<div class="dx-texteditor-label" style="left: 16px;z-index:1;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
        }

        var $TableGeneral = $("<table style='width:100%;'/>").appendTo(container)
        var $TrGeneral = $("<tr/>").appendTo($TableGeneral)
        var $Td = $("<td style='width:100%;'/>").appendTo($TrGeneral)

        // Création du conteneur principal
        var $Div1 = $("<div class='dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-filled dx-widget' style='overflow:visible;width:100%;'/>").appendTo($Td);
        var $Div2 = $("<div class='dx-texteditor-container' style='overflow:visible;width:100%;'/>").appendTo($Div1);
        var $Div3 = $("<div class='dx-texteditor-input-container' style='overflow:visible;width:100%;'/>").appendTo($Div2);
        var $Table = $("<table style='width:100%'/>").appendTo($Div3);
        var $Tr = $("<tr/>").appendTo($Table);
        var $TdInput = $("<td style='width:100%'/>").appendTo($Tr);
        var $TdValide = $("<td style='width:0px;display:none;padding:0 5px;'/>").appendTo($Tr);
        var $Input = $("<input type='tel' class='dx-texteditor-input' style='width:100%;padding-top:12px;padding-bottom:13px;margin-left:0px;'/>").appendTo($TdInput);

        // Initialisation de intlTelInput
        var opt = {
            utilsScript: parametre.urldispatch + "/js/plugin/intTel/utils.js",
            initialCountry: "fr",
            showSelectedDialCode: true,
            useFullscreenPopup: false,
            strictMode: true,
            showFlags: (typeof option.showFlags == 'undefined') ? true : option.showFlags,
            searchPlaceholder: "Recherche..."
        };

        dxItiTel = window.intlTelInput($Input[0], opt);
        dxItiTel.input = $Input[0];
        dxItiTel.hasValue = function () {
            return ($Input[0].value.trim().length > 0);
        };
        dxItiTel.$TdValide = $TdValide;

        // Appliquer la valeur initiale
        if (typeof option.value.tel_complet == 'undefined' || option.value.tel_complet == null) {
            option.value.tel_complet = "";
        }
        dxItiTel.setNumber(option.value.tel_complet, true); // <-- true pour forcer le formatage
        $Input.trigger("blur"); // <-- Force le formatage si nécessaire

        // Style personnalisé
        $Div1.find(".iti__dropdown-content").addClass("dx-accordion").css("border", "none");
        $Div1.find(".iti__search-input").addClass("dx-accordion").css("border", "none");
        //$Div1.find(".iti__selected-dial-code").css("display", "barlow condensed");
        $Div1.find(".iti__selected-dial-code").css("font-family", "'Barlow Condensed', sans-serif");
        if (option.stylingMode == "outlined") {
            $Div1.find(".iti--allow-dropdown").css("background", "#fff");
        }

        if (typeof option.height != 'undefined' && option.height != null) {
            $Input.css({
                "height": option.height + "px",
                "padding-top": "0",
                "padding-bottom": "0"
            });
        }

        // Gestion des événements
        $Input[0].addEventListener("countrychange", function () {
            isDirty = true;
            option.value = mGetValue();
            mVerifSaisie()
            if (typeof option.onValueChanged != 'undefined') {
                option.onValueChanged({ value: mGetValue() });
            }
        });

        $Input[0].addEventListener('change', function () {
            if (isDirty) {
                option.value = mGetValue();
                mVerifSaisie();
                if (typeof option.onValueChanged != 'undefined') {
                    option.onValueChanged({ value: mGetValue() });
                }
                isDirty = false;
            }
        });

        $Input[0].addEventListener('keyup', function (e) {
            if (option.value.tel_complet != mGetValue().tel_complet) {
                mVerifSaisie();
            }
            if (e.which == 13) {
                try { $Input.blur(); } catch (e) { }
            } else {
                isDirty = true
                option.value = mGetValue()
            }
        });

        //$Input.on("keypress", function (e) {
        //    if (e.which == 13) {
        //        try { $Input.blur(); } catch (e) { }
        //    } else {
        //        isDirty = true
        //        option.value = mGetValue()
        //    }
        //});

        $Input.attr("maxlength", 48);

        $Input[0].addEventListener('focusin', function (e) {
            if (typeof option.onFocusIn != 'undefined') {
                option.onFocusIn({
                    component: { element: function () { return container; } },
                    element: container,
                    event: e,
                    value: mGetValue()
                });
            }
        });

        // Initialisation de la validation
        oldValue = JSON.parse(JSON.stringify(option.value));
        window.setTimeout(function () { mVerifSaisie(); }, 500);

        // Gestion du tooltip
        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"));
        }

        if (option.buttons) option.buttons.forEach(function (item) {
            var $Td = $("<td style='width:1px;'/>").appendTo($TrGeneral)
            $("<div/>").appendTo($Td).dxButton(item.options)
        })

        // Gestion du focus
        if (typeof option.onContentReady != 'undefined') {
            option.onContentReady({
                component: { element: function () { return container; } },
                element: container
            });
        }
    }

    this.mSetValue = function (value) {
        option.value = value;
        dxItiTel.setNumber(option.value.tel_complet);
        mVerifSaisie();
    }

    const numberType = {
        "FIXED_LINE": 0,
        "MOBILE": 1,
        "FIXED_LINE_OR_MOBILE": 2,
        "TOLL_FREE": 3,
        "PREMIUM_RATE": 4,
        "SHARED_COST": 5,
        "VOIP": 6,
        "PERSONAL_NUMBER": 7,
        "PAGER": 8,
        "UAN": 9,
        "VOICEMAIL": 10,
        "UNKNOWN": -1
    };

    function mGetValue() {
        var value = {
            tel_code_pays: dxItiTel.getSelectedCountryData().iso2,
            tel_indic_pays: dxItiTel.getSelectedCountryData().dialCode,
            tel_number: "",
            tel_complet: "",
            tel_sms: "",
            tel_error: -1,
            tel_num_type: ((dxItiTel.getNumberType() == -99) ? -1 : dxItiTel.getNumberType())
        };
        var errorCode = null;

        if (!dxItiTel.hasValue()) {
            // Rien à faire
        } else if (dxItiTel.isValidNumber()) {
            value.tel_complet = dxItiTel.getNumber();
            value.tel_number = value.tel_complet.replace("+" + value.tel_indic_pays, "");
            value.tel_sms = value.tel_indic_pays + ((value.tel_number.startsWith("0")) ? value.tel_number.substring(1) : value.tel_number);

            if (value.tel_number.startsWith("0")) {
                if (value.tel_number.length == dxItiTel.maxCoreNumberLength + 1) {
                    value.tel_error = -1;
                } else {
                    value.tel_error = ((value.tel_number.length > dxItiTel.maxCoreNumberLength + 1) ? 3 : 2);
                }
            } else {
                if (value.tel_number.length == dxItiTel.maxCoreNumberLength) {
                    value.tel_error = -1;
                } else {
                    value.tel_error = ((value.tel_number.length > dxItiTel.maxCoreNumberLength) ? 3 : 2);
                }
            }

            if (value.tel_error == -1) {
                if (typeof option.typeTel != "undefined" && option.typeTel != "") {
                    if (value.tel_num_type == 1 && option.typeTel == "tel") {
                        value.tel_error = 4;
                    } else if (value.tel_num_type == 0 && option.typeTel == "mob") {
                        value.tel_error = 5;
                    }
                }
            }
        } else {
            value.tel_number = dxItiTel.getNumber().remplacerTout(" ", "").replace("+" + value.tel_indic_pays, "");
            value.tel_complet = "+" + value.tel_indic_pays + value.tel_number;
            value.tel_sms = value.tel_indic_pays + ((value.tel_number.startsWith("0")) ? value.tel_number.substring(1) : value.tel_number);
            value.tel_error = dxItiTel.getValidationError();
            if (value.tel_error == 4) value.tel_error = 0;
        }
        return value;
    }

    function mVerifSaisie() {
        if (option.disableVerifSaisie) {
            dxItiTel.$TdValide.hide();
            return
        }
        option.value = mGetValue();
        if (option.value.tel_sms != oldValue.tel_sms) isDirty = true;
        oldValue = JSON.parse(JSON.stringify(option.value));

        if (option.value.tel_number.length == 0) {
            dxItiTel.$TdValide.hide();
        } else if (option.value.tel_error == -1) {
            dxItiTel.$TdValide.show();
            dxItiTel.$TdValide.html("<i class='fas fa-check' style='color:green'></i>");
            dxItiTel.$TdValide.attr("title", "");
        } else {
            const msg = errorMapTelephone[option.value.tel_error] || "Numéro invalide";
            dxItiTel.$TdValide.show();
            dxItiTel.$TdValide.html("<i class='fas fa-triangle-exclamation' style='color:red'></i>");
            dxItiTel.$TdValide.attr("title", msg);
        }
    }

    this.hasValue = function () {
        return dxItiTel.hasValue();
    }

    this.focus = function () {
        dxItiTel.input.focus();
    }

    this.element = function () { return container; }

    mConstruit();
}

window.msAddCaractereTel = function (Tel, Car) {
    if (Tel == null) return Tel;
    if (!Car) Car = ".";
    var reg = new RegExp("[" + Car + "]", "gi");
    Tel = Tel.replace(reg, '');
    var reg = new RegExp("[ ]", "gi");
    Tel = Tel.replace(reg, '');
    Tel = Tel.replace(/(.{2})(?!$)/g, "$1" + Car);
    return Tel;
};